import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import Footer from "../../components/Footer/Footer";
import PreLoginHeader from "../../components/PreLoginHeader/PreLoginHeader";
import consultimg1 from "../../assets/img/consultimg1.svg";
import consultimg2 from "../../assets/img/consultimg2.svg";
import consultimg3 from "../../assets/img/consultimg3.svg";
import "./Register.scss";

import { useNavigate, Link, useLocation } from "react-router-dom";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import {
  SignUpSchema,
  ProviderSignUpSchema,
} from "../../validations/validation";
import { SubmitData } from "../../services/apiService";
import {
  decryptedData,
  makeEncryptionData,
} from "../../services/encryptionDecription.service";
import useAlertUtils from "../../utils/common.utils";
import { trackAccountCreation } from "../../utils/gtmTracking";

function Register() {
  const [passwordType, setPasswordType] = useState("password");
  const [userType, setUserType] = useState("patient");
  const { alertSuccess, alertError } = useAlertUtils();
  const navigate = useNavigate();

  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);

  const procedure = queryParams.get("procedure");
  const productId = queryParams.get("productId");

  useEffect(() => {
    if (procedure && productId) {
      localStorage.setItem("procedure", procedure);
      localStorage.setItem("productId", productId);
    }

    const token = localStorage.getItem("token");
    let role = localStorage.getItem("uR");

    if (token && role && procedure && productId) {
      role = decryptedData(role);
      if (role === "patient") {
        navigate("/app/medical-history");
      }
    } else {
      if (location.pathname && location.search) {
        localStorage.setItem("productURL", location.pathname + location.search);
      }
    }
  }, [procedure, productId, navigate]);

  const handleUserTypeChange = (type) => {
    setUserType(type);
    if (type === "patient") {
      patientFormik.resetForm();
    } else {
      providerFormik.resetForm();
    }
  };

  const patientFormik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
      password: "",
      checkTick: null,
    },
    validationSchema: SignUpSchema,
    onSubmit: async (values) => {
      try {
        const encryptedData = makeEncryptionData(values);
        encryptedData.role = 2;
        encryptedData.agreeTerms = values?.checkTick ? 1 : 0;

        delete encryptedData.checkTick;

        if (encryptedData) {
          const response = await SubmitData("/api/users/signup", encryptedData);
          if (response?.success) {
            trackAccountCreation();
            alertSuccess(
              "A verification email has been sent to your registered email"
            );
            navigate("/");
          } else {
            alertError(response?.message);
          }
        }
      } catch (error) {
        alertError("An error occurred during signup. Please try again.");
      }
    },
  });

  const providerFormik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
      password: "",
      checkTick: null,
      npiNumber: "",
      licenseNumber: "",
      licenseState: "",
      organizationName: "",
      phoneNumber: "",
    },
    validationSchema: ProviderSignUpSchema,
    onSubmit: async (values) => {
      try {
        const encryptedData = makeEncryptionData(values);
        encryptedData.role = 1;
        encryptedData.agreeTerms = values?.checkTick ? true : false;

        delete encryptedData.checkTick;

        if (encryptedData) {
          const response = await SubmitData(
            "/api/users/register-provider",
            encryptedData
          );
          if (response?.success) {
            trackAccountCreation();
            alertSuccess(
              "A verification email has been sent to your registered email"
            );
            navigate("/");
          } else {
            alertError(response?.message);
          }
        }
      } catch (error) {
        alertError("An error occurred during signup. Please try again.");
      }
    },
  });

  const currentFormik = userType === "patient" ? patientFormik : providerFormik;
  return (
    <>
      <PreLoginHeader></PreLoginHeader>
      <div className="main_content consultation_homepage">
        <div className="container">
          <div className="row">
            <div className="col-md-6 col-lg-7">
              <div className="consult_login">
                <div className="testimonial_inner">
                  <form noValidate onSubmit={currentFormik?.handleSubmit}>
                    <h1 className="login_title">Create An Account</h1>

                    <div className="user_type_toggle">
                      <button
                        type="button"
                        className={`toggle_btn ${
                          userType === "patient" ? "active" : ""
                        }`}
                        onClick={() => handleUserTypeChange("patient")}
                      >
                        I am a Patient
                      </button>
                      <button
                        type="button"
                        className={`toggle_btn ${
                          userType === "provider" ? "active" : ""
                        }`}
                        onClick={() => handleUserTypeChange("provider")}
                      >
                        I am a Provider
                      </button>
                    </div>

                    <div className="row">
                      <div className="col-sm-6">
                        <div className="form_field_wrapper">
                          <label>First Name</label>
                          <input
                            type="text"
                            name="firstName"
                            onChange={currentFormik?.handleChange}
                            onBlur={currentFormik?.handleBlur}
                            value={currentFormik?.values?.firstName}
                            placeholder="Enter First Name"
                            className="form-control inp_text"
                            id="firstName"
                          />
                          <p className="error">
                            {currentFormik?.errors?.firstName &&
                              currentFormik?.touched?.firstName &&
                              currentFormik?.errors?.firstName}
                          </p>
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="form_field_wrapper">
                          <label>Last Name</label>
                          <input
                            type="text"
                            name="lastName"
                            onChange={currentFormik?.handleChange}
                            onBlur={currentFormik?.handleBlur}
                            value={currentFormik?.values?.lastName}
                            placeholder="Enter Last Name"
                            className="form-control inp_text"
                            id="lastName"
                          />
                          <p className="error">
                            {currentFormik?.errors?.lastName &&
                              currentFormik?.touched?.lastName &&
                              currentFormik?.errors?.lastName}
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="form_field_wrapper">
                      <label>Email</label>
                      <input
                        type="email"
                        name="email"
                        onChange={currentFormik?.handleChange}
                        onBlur={currentFormik?.handleBlur}
                        value={currentFormik?.values?.email}
                        placeholder="Enter Email"
                        className="form-control inp_text"
                        id="email"
                      />
                      <p className="error">
                        {currentFormik?.errors?.email &&
                          currentFormik?.touched?.email &&
                          currentFormik?.errors?.email}
                      </p>
                    </div>

                    <div className="form_field_wrapper">
                      <label>Password</label>
                      <div className="password-input-wrapper">
                        <input
                          type={passwordType}
                          name="password"
                          onChange={currentFormik?.handleChange}
                          onBlur={currentFormik?.handleBlur}
                          value={currentFormik?.values?.password}
                          placeholder="Enter Password"
                          className="form-control mb-2"
                        />
                        {passwordType === "text" ? (
                          <VisibilityIcon
                            onClick={() => {
                              setPasswordType("password");
                            }}
                          />
                        ) : (
                          <VisibilityOffIcon
                            onClick={() => {
                              setPasswordType("text");
                            }}
                          />
                        )}
                      </div>

                      <p className="error">
                        {currentFormik?.errors?.password &&
                          currentFormik?.touched?.password &&
                          currentFormik?.errors?.password}
                      </p>
                    </div>

                    {userType === "provider" && (
                      <>
                        <div className="form_field_wrapper">
                          <label>NPI Number</label>
                          <input
                            type="text"
                            name="npiNumber"
                            onChange={currentFormik?.handleChange}
                            onBlur={currentFormik?.handleBlur}
                            value={currentFormik?.values?.npiNumber}
                            placeholder="Enter NPI Number"
                            className="form-control inp_text"
                            id="npiNumber"
                          />
                          <p className="error">
                            {currentFormik?.errors?.npiNumber &&
                              currentFormik?.touched?.npiNumber &&
                              currentFormik?.errors?.npiNumber}
                          </p>
                        </div>

                        <div className="row mt-4">
                          <div className="col-sm-6">
                            <div className="form_field_wrapper">
                              <label>License Number</label>
                              <input
                                type="text"
                                name="licenseNumber"
                                onChange={currentFormik?.handleChange}
                                onBlur={currentFormik?.handleBlur}
                                value={currentFormik?.values?.licenseNumber}
                                placeholder="Enter License Number"
                                className="form-control inp_text"
                                id="licenseNumber"
                              />
                              <p className="error">
                                {currentFormik?.errors?.licenseNumber &&
                                  currentFormik?.touched?.licenseNumber &&
                                  currentFormik?.errors?.licenseNumber}
                              </p>
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div className="form_field_wrapper">
                              <label>License State</label>
                              <input
                                type="text"
                                name="licenseState"
                                onChange={currentFormik?.handleChange}
                                onBlur={currentFormik?.handleBlur}
                                value={currentFormik?.values?.licenseState}
                                placeholder="Enter License State"
                                className="form-control inp_text"
                                id="licenseState"
                              />
                              <p className="error">
                                {currentFormik?.errors?.licenseState &&
                                  currentFormik?.touched?.licenseState &&
                                  currentFormik?.errors?.licenseState}
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="row mt-2">
                          <div className="col-sm-6">
                            <div className="form_field_wrapper">
                              <label>Organization Name</label>
                              <input
                                type="text"
                                name="organizationName"
                                onChange={currentFormik?.handleChange}
                                onBlur={currentFormik?.handleBlur}
                                value={currentFormik?.values?.organizationName}
                                placeholder="Enter Organization Name"
                                className="form-control inp_text"
                                id="organizationName"
                              />
                              <p className="error">
                                {currentFormik?.errors?.organizationName &&
                                  currentFormik?.touched?.organizationName &&
                                  currentFormik?.errors?.organizationName}
                              </p>
                            </div>
                          </div>

                          <div className="col-sm-6">
                            <div className="form_field_wrapper">
                              <label>Phone Number</label>
                              <input
                                type="tel"
                                name="phoneNumber"
                                onChange={currentFormik?.handleChange}
                                onBlur={currentFormik?.handleBlur}
                                value={currentFormik?.values?.phoneNumber}
                                placeholder="Enter Phone Number"
                                className="form-control inp_text"
                                id="phoneNumber"
                              />
                              <p className="error">
                                {currentFormik?.errors?.phoneNumber &&
                                  currentFormik?.touched?.phoneNumber &&
                                  currentFormik?.errors?.phoneNumber}
                              </p>
                            </div>
                          </div>
                        </div>
                      </>
                    )}

                    <label className="mt-3">
                      <input
                        type="checkbox"
                        onChange={currentFormik?.handleChange}
                        onBlur={currentFormik?.handleBlur}
                        value={currentFormik?.values?.checkTick}
                        id="checkTick"
                        name="checkTick"
                      />
                      <span>
                        {" "}
                        I agree to the{" "}
                        <Link to="/terms-and-conditions">
                          Terms And Conditions
                        </Link>
                        , <Link to="/privacy-policy">Privacy Policy</Link> and{" "}
                        <Link to="/consent">Telehealth Consent</Link>.
                      </span>
                    </label>
                    <p className="error">
                      {currentFormik?.errors?.checkTick &&
                        currentFormik?.touched?.checkTick &&
                        currentFormik?.errors?.checkTick}
                    </p>
                    <button
                      type="submit"
                      className="btn btn-primary signup_btn"
                    >
                      Sign Up
                    </button>

                    <div className="form_field_wrapper backtologin_block">
                      <Link className="linkto backtologin" to="/">
                        Already Have An Account?{" "}
                        <span className="login_txt">Login</span>
                      </Link>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-5">
              <div className="testimonial">
                <div className="testimonial_inner">
                  <div className="consultation_block">
                    <h2 className="main_title">
                      Start Your Free Consultation With Our Platform
                    </h2>
                    <div className="row">
                      <div className="col-12  consult_item">
                        <div className="consult_item_inner">
                          <img src={consultimg1} alt="Consult Image1" />
                          <div className="consult_desc">
                            <h3 className="title">Care</h3>
                            <div className="desc">
                              Ongoing support from our care team
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-12  consult_item">
                        <div className="consult_item_inner">
                          <img src={consultimg2} alt="Consult Image2" />
                          <div className="consult_desc">
                            <h3 className="title">Free Shipping</h3>
                            <div className="desc">
                              Delivered to your doorstep
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 consult_item">
                        <div className="consult_item_inner">
                          <img src={consultimg3} alt="Consult Image3" />
                          <div className="consult_desc">
                            <h3 className="title">Medical Evaluation</h3>
                            <div className="desc">
                              Medical assesments and prescriptions provided by
                              licensed prescriber in the U.S.
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer></Footer>
    </>
  );
}

export default Register;
